import React, { useMemo, useState } from 'react';
import { Info } from 'lucide-react';
import { useSAData } from './useSAData';
import { SAKpis } from './SAKpis';
import { Loading } from './Loading';
import { ServerTable } from './ServerTable';
import { MRP_COLS } from './columns';

const D = (flag) => ({ patch: { flag: ['active_docs', flag] }, tab: 'mrp' });
const KPIS = [
  { key: 'batch_diff', label: 'Products: Batch MRP ≠ MRP', warn: true, drill: D('mrp_diff') },
  { key: 'po_diff', label: 'Products: PO MRP ≠ MRP', warn: true, drill: D('mrp_diff') },
  { key: 'grn_diff', label: 'Products: GRN MRP ≠ MRP', warn: true, drill: D('mrp_diff') },
  { key: 'master_diff', label: 'Products: Current Master MRP ≠ MRP', warn: true, drill: D('mrp_diff') },
  { key: 'om_change_lines', label: 'Outward Margin Changes (lines)', warn: true, note: (d) => `Value ₹${Number(d.om_change_value || 0).toLocaleString('en-IN')} = Σ (Master/Batch MRP − MRP) × Qty` },
  { key: 'missing_snapshots', label: 'Products with Missing MRP Snapshots', warn: true, drill: D('mrp_any') },
  { key: 'master_below_batch', label: 'Master MRP Below Batch MRP', warn: true, drill: D('master_below_batch') },
  { key: 'master_above_batch', label: 'Master MRP Above Batch MRP', warn: true, drill: D('master_above_batch') },
];

export const MrpTab = ({ params, onDrill }) => {
  const { data, loading } = useSAData('/mrp', params);
  const [onlyDiff, setOnlyDiff] = useState(true);
  const tableParams = useMemo(() => {
    const flags = (params.flag || '').split('|').filter(Boolean);
    const base = ['active_docs', ...(onlyDiff && !flags.some((x) => x.startsWith('mrp') || x.startsWith('master')) ? ['mrp_any'] : [])];
    return { ...params, flag: [...new Set([...flags, ...base])].join('|') };
  }, [params, onlyDiff]);
  return (
    <div className="space-y-4 relative">
      <Loading on={loading} />
      <div className="flex gap-2 rounded-lg border border-orange-200 bg-orange-50 px-4 py-2 text-[11px] text-[#3b2416]" data-testid="sa-mrp-note">
        <Info size={14} className="shrink-0 mt-0.5 text-orange-600" />
        <span>MRP, Batch MRP, PO MRP, GRN MRP and Current Master MRP are separate snapshots with different meanings and are never treated as interchangeable.
          MRP Difference = (Current Master MRP, else Batch MRP) − document MRP. Outward Margin Difference = that difference × Qty.
          The ERP keeps no MRP change history, so no change date is inferred — only which snapshots differ.</span>
      </div>
      <SAKpis items={KPIS} data={data?.kpis} onDrill={onDrill} testPrefix="sa-mrp" />
      <label className="flex items-center gap-2 text-xs text-stone-700">
        <input type="checkbox" checked={onlyDiff} onChange={(e) => setOnlyDiff(e.target.checked)} data-testid="sa-mrp-only-diff" />
        Show only lines with MRP differences or missing snapshots (drafts/cancelled excluded)
      </label>
      <ServerTable endpoint="/transactions" params={tableParams} columns={MRP_COLS} testId="sa-mrp-table" defaultSort="mrp_diff_amount" />
    </div>
  );
};
